import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

const defaultFont = `14px/18px
'Source Sans Pro',
Helvetica,
Arial,
Geneva,
sans-serif`;

const usePrimaryColor = ["primary", "classicBlue", "secondary"];

const InputBox = styled.span`
  background-color: ${props =>
    usePrimaryColor.includes(props.theme) && props.checked
      ? colorPalette.primary
      : "white"};
  border: 1px solid
    ${props => {
      if (props.theme === "secondary") {
        return colorPalette.koalaGrey;
      } else if (
        (props.theme === "primary" || props.theme === "classicBlue") &&
        props.checked
      ) {
        return colorPalette.primary;
      }
      return colorPalette.foxGrey;
    }};
  border-radius: 2px;
  box-sizing: border-box;
  display: inline-block;
  flex: 0 0 auto;
  height: 18px;
  position: relative;
  transition: background 200ms, border 200ms;
  vertical-align: middle;
  width: 18px;

  ${({ isDisabled }) =>
    isDisabled &&
    `
      background-color: ${colorPalette.foxGrey};
      border: 1px solid ${colorPalette.foxGrey};
    `}

  &:after {
    color: ${({ isDisabled, theme }) =>
      usePrimaryColor.includes(theme) || isDisabled
        ? "white"
        : colorPalette.primary};
    content: "\f00c";
    display: block;
    font-family: FontAwesome;
    font-size: 14px;
    left: 50%;
    line-height: 14px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%)
      scale(${props => (props.checked ? "1, 1" : "0, 0")});
    transition: transform 200ms;
  }
`;

const CheckboxInput = styled.input.attrs({
  type: "checkbox"
})`
  // Taken from: https://a11yproject.com/posts/how-to-hide-content/
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:focus + ${InputBox} {
    outline: 5px auto -webkit-focus-ring-color;
  }
`;

const CheckboxLabel = styled.label`
  align-items: ${props => props.checkboxPosition};
  cursor: pointer;
  display: flex;
  position: relative;
  user-select: none;
`;

const LabelCopy = styled.span`
  color: ${colorPalette.whaleGrey};
  font: ${defaultFont};
  margin-left: 10px;
  vertical-align: middle;
`;

CheckboxLabel.displayName = "CheckboxLabel";
CheckboxInput.displayName = "CheckboxInput";
InputBox.displayName = "InputBox";
LabelCopy.displayName = "LabelCopy";

export { CheckboxInput, CheckboxLabel, InputBox, LabelCopy };
